import { render, staticRenderFns } from "./mawbInfoOtherChargeForm.vue?vue&type=template&id=5334b47c&"
import script from "./mawbInfoOtherChargeForm.vue?vue&type=script&lang=js&"
export * from "./mawbInfoOtherChargeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5334b47c')) {
      api.createRecord('5334b47c', component.options)
    } else {
      api.reload('5334b47c', component.options)
    }
    module.hot.accept("./mawbInfoOtherChargeForm.vue?vue&type=template&id=5334b47c&", function () {
      api.rerender('5334b47c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/mawbInfoOtherChargeForm.vue"
export default component.exports